import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';

function Ourspecialitesabout() {
  const captionStyleheader = {
    textAlign: 'center',
    padding: '2px',
  };

  const captionStyle = {
    textAlign: 'center',
    padding: '2px',
    marginBottom: '10px',
    boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
    border: 'none',
  };

  const captionStyleBottom = {
    textAlign: 'center',
    padding: '2px',
    marginBottom: '90px',
    boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.1)',
    borderRadius: '10px',
    border: 'none',
  };

  const captionTextStyle = {
    fontSize: '2rem',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: '#2855A1',
    marginTop: '2rem',
  };

  const captionTextStyle2 = {
    fontSize: '2rem',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: 'black',
  };

  const captionTextStyleCard = {
    fontSize: '1.2rem',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    marginTop: '2rem',
    marginBottom: '30px',
    color: '#2855A1',
  };

  const captionTextStyleCard2 = {
    fontSize: '1.2rem',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    marginTop: '2rem',
    marginBottom: '30px',
    color: 'black',
  };

  const captionTextStyle3 = {
    fontSize: "0.9rem",
    textOverflow: "ellipsis",
    color: "black",
    fontWeight: 600,
    textAlign: "center",
    lineHeight: "3",
    marginBottom: "2rem",
  };

  const imageStyle = {
    marginBottom: '5px',
    marginTop: '5px',
    width: '204px',
    height: '200px',
    objectFit: 'cover',
    filter: 'opacity(3) brightness(1)',
  };

  return (
    <Container fluid style={{ marginBottom: '10px', height: 'auto', marginTop: '10px' }}>
      <Container style={{ padding: '2px', marginTop: '50px' }}>
        <div style={captionStyleheader}>
          <h3 style={captionTextStyle}>
            <span style={captionTextStyle2}>Our</span> Specialities
          </h3>
        </div>
      </Container>

      <Container style={{ padding: '2px', marginTop: '50px' }}>
        <Row className="justify-content-center">
          <Col xs={12} md={12} lg={6}  className="mb-4">
            <div className="card h-100" style={captionStyle}>
              <div className="card-body">
                <Image src={process.env.PUBLIC_URL + '/assets/images/Group1.png'} alt="" style={imageStyle} />
                <h3 style={captionTextStyleCard}>
                  Emirati / Saudi <span style={captionTextStyleCard2}>Talent Acquisition</span>
                </h3>
                <p
                  className="normal-text"
                  style={{
                    ...captionTextStyle3,
                    width: "100%",
                    textAlign: "justify",
                    marginBottom: "1rem",
                    marginTop: "1rem"
                  }}
                >
                Our Emirati / Saudi talent acquisition service is a clear demonstration of our commitment to localization initiatives, specially Emiratization in the UAE and Saudization in Saudi Arabia. This commitment is all about brining local Emirati and Saudi talent into the corporate world. We’re focused on finding individuals from these communities who are not just well-educated and passionate about their work, but also bring a deep understanding of local culture and business needs – key ingredients for your business’s growth. We do more than just standard recruitment; we aim for a perfect match between your business needs and the right local talent. As your partners, we navigate the complexities of recruitment in the UAE and Saudi Arabia with strategic, cost-effective solutions. Our goal? To make hiring easier for you and to ensure your business grows by levering the rich local talent pool. In doing so, we’re not just following Emiratization and Saudization guidelines, but also enhancing your business with strong, locally-focused partnership and success in the vibrant markets.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6}  className="mb-4">
            <div className="card h-100" style={captionStyle}>
              <div className="card-body">
                <Image src={process.env.PUBLIC_URL + '/assets/images/Group2.png'} alt="" style={imageStyle} />
                <h3 style={captionTextStyleCard}>
                  Skilled <span style={captionTextStyleCard2}>Talent Acquisition</span>
                </h3>
                <p
                  className="normal-text"
                  style={{
                    ...captionTextStyle3,
                    width: "100%",
                    textAlign: "justify",
                    marginBottom: "1rem",
                    marginTop: "1rem"
                  }}
                >
                  At Ascent, we excel in connecting your business with the world's best skilled professionals, handpicked for their up-to-date expertise in their respective fields. Our approach is uniquely tailored, ensuring a seamless alignment between our extensive global network of highly skilled candidates and your specific business requirements and culture. We specialize in bringing you professionals who are not just experts in their domains but are continually evolving with their industries, guaranteeing a dynamic and productive integration into your workforce. Our commitment is to surpass your expectations with our precision in talent matching and efficiency in the recruitment process. With Ascent, you're not just hiring employees; you're embracing partners who are as dedicated to driving your business forward as you are.                </p>
              </div>
            </div>
          </Col>
        </Row>

         {/* Second Row */}
         <Row className="justify-content-center mb-4" style={{ marginBottom: '100px' }}>
          <Col xs={12} md={12} lg={6}  className="mb-4">
            <div className="card h-100" style={captionStyle}>
              <div className="card-body">
                <Image src={process.env.PUBLIC_URL + '/assets/images/Group3.png'} alt="" style={imageStyle} />
                <h3 style={captionTextStyleCard}>
                  Talent Training <span style={captionTextStyleCard2}>and Development</span>
                </h3>
                <p
                  className="normal-text"
                  style={{
                    ...captionTextStyle3,
                    width: "100%",
                    textAlign: "justify",
                    marginBottom: "1rem",
                    marginTop: "1rem"
                  }}
                >
                    With the aim of empowering professionals with cutting-edge skills and knowledge tailored to current industry demands, we provide carefully curated skill development courses designed with a clear understanding of what today’s dynamic work environments require. Each course, meticulously prepared by experienced industry experts, focuses on enhancing specific skills and knowledge relevant to learner’s professional fields. Whether it’s honing interview techniques or mastering advanced excel functionalities, our diverse range of short courses also covers crucial areas such as integrating artificial intelligence into the workplace and much more. This approach ensures that professionals not only stay abreast of industry developments but also gain practical, applicable skills to excel in their careers. Our commitment is to provide training that translates into real-world expertise, driving both individual and organizational success.              
                    </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6}  className="mb-4">
            <div className="card h-100" style={captionStyleBottom}>
              <div className="card-body">
                <Image src={process.env.PUBLIC_URL + '/assets/images/Group4.png'} alt="" style={imageStyle} />
                <h3 style={captionTextStyleCard}>
                  Executive <span style={captionTextStyleCard2}>Search</span>
                </h3>
                <p
                  className="normal-text"
                  style={{
                    ...captionTextStyle3,
                    width: "100%",
                    textAlign: "justify",
                    marginBottom: "1rem",
                    marginTop: "1rem"
                  }}
                >
                  Dedicated to excellence in leadership acquisition, our Executive Search service is deeply aligned with your pursuit of outstanding leadership. We concentrate on finding leaders who not only fit your strategic goals but also have the potential to transform your organization. With a wide-reaching network and keen industry knowledge, we carefully select candidates who offer the right mix of skills and experience, while also fitting into your company's culture and values. Our method is detailed and personalized, prioritizing lasting impact over immediate results. We work closely with you to fully understand your leadership requirements, ensuring we present candidates capable of overcoming complex challenges and fostering enduring growth. Our commitment is to simplify the search for exceptional leaders for you, enhancing your business with leaders who can navigate the unique demands of your market.                     </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Ourspecialitesabout;